module.exports = __webpack_public_path__ + "static/slider-1-1-7e4efde87d0ed87bf1465cdd55c47486.jpg";